import axios from 'axios';

let subscriptionForms = document.querySelectorAll('[data-subscription]');

subscriptionForms.forEach(form => {
    form.addEventListener('submit',
        event => {
            event.preventDefault();
            let currentForm = event.target;
            axios.post(currentForm.action, new FormData(currentForm), {
                headers: {
                    'X-Requested-With': 'XMLHttpRequest'
                }
            }).then(response => {
                let emailId = currentForm.dataset['subscription'];
                let messageId = emailId + '-description';

                if (!document.getElementById(messageId)) {
                    let validationMessage = document.createElement('div');
                    validationMessage.classList.add('subscription-feedback');
                    validationMessage.innerHTML = response.data;
                    validationMessage.setAttribute('role', 'alert');
                    validationMessage.id = messageId;
                    currentForm.insertAdjacentElement('afterend', validationMessage);
                } else {
                    document.getElementById(messageId).innerHTML = response.data;
                }
                if (document.getElementById(emailId)) {
                    document.getElementById(emailId).setAttribute('aria-describedby', messageId);
                }
            });
        });
})